import utils from './utils'
import barMethods from './barMethods'
import dataRender from './dataRender'

const combinedExports = {
    ...utils,
    ...barMethods,
    ...dataRender
  };
  
  // 导出这个对象
  export default combinedExports;

